import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { cancelTask } from '@/service/serverless-gpu';
import { useServerlessStore } from '@/store/serverless';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

const CancelPage = () => {
  const [searchParams] = useSearchParams();
  const { token } = useServerlessStore();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  const taskId = searchParams.get('task_id');

  useEffect(() => {
    if (!taskId) {
      setStatus('error');
      setMessage('Missing task_id parameter');
      return;
    }

    if (!token) {
      setStatus('error');
      setMessage('Not authenticated');
      return;
    }

    cancelTask(taskId, token)
      .then(() => {
        setStatus('success');
        setMessage(`Task ${taskId} cancel request sent`);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.message);
      });
  }, [taskId, token]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        {status === 'loading' && (
          <Loader2 className="h-12 w-12 animate-spin mx-auto text-primary" />
        )}
        {status === 'success' && (
          <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
        )}
        {status === 'error' && (
          <XCircle className="h-12 w-12 text-red-500 mx-auto" />
        )}
        <p className="text-lg">{message || 'Cancelling task...'}</p>
      </div>
    </div>
  );
};

export default CancelPage;
